import {ValueObject} from '@s-ui/domain'

export default class TaxValueObject extends ValueObject {
  /**
   * @param {Object} tax
   * @param {String} tax.type
   * @param {Number} tax.percentage
   * @param {Number} tax.amount
   * */

  getTax = () => {
    return {
      type: this._type,
      percentage: this._percentage,
      amount: this._amount
    }
  }
}
